import { DesktopDateTimePicker } from '@mui/x-date-pickers/DesktopDateTimePicker';
import { MobileDateTimePicker } from '@mui/x-date-pickers/MobileDateTimePicker';
import { isMobile } from '../utils';

export default function useDateTimePicker() {
  return isMobile ? MobileDateTimePicker : DesktopDateTimePicker;
}